import React, { useState } from 'react'
import EmailCaptureDebug from './EmailCaptureDebug'
import DiscountDebug from './DiscountDebug'
import ErrorBoundaryDebug from './ErrorBoundaryDebug'

type DebugComponent = 'email' | 'discount' | 'errors' | null

const DebugHolder: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [activeComponent, setActiveComponent] = useState<DebugComponent>(null)

    // Hide in production or if explicitly disabled via env var
    if (process.env.NODE_ENV !== 'development' || process.env.REACT_APP_DEBUG_TOOLS_ENABLED === 'false') {
        return null
    }

    const renderDebugComponent = () => {
        switch (activeComponent) {
            case 'email':
                return <EmailCaptureDebug />
            case 'discount':
                return <DiscountDebug />
            case 'errors':
                return <ErrorBoundaryDebug />
            default:
                return null
        }
    }

    const handleComponentSelect = (component: DebugComponent) => {
        setActiveComponent(component === activeComponent ? null : component)
        setIsModalOpen(false)
    }

    return (
        <>
            {/* Toggle Button */}
            <button
                onClick={() => setIsModalOpen(true)}
                className="fixed bottom-4 right-4 z-[1000] bg-gray-800 text-white px-3 py-1 rounded-full text-xs hover:bg-gray-700 flex items-center gap-2"
            >
                <span>Debug Tools</span>
                {activeComponent && (
                    <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" />
                )}
            </button>

            {/* Modal Selector */}
            {isModalOpen && (
                <>
                    {/* Modal Backdrop */}
                    <div
                        className="fixed inset-0 bg-black/50 z-[999]"
                        onClick={() => setIsModalOpen(false)}
                    />

                    {/* Modal Content */}
                    <div className="fixed bottom-16 right-4 bg-white rounded-lg shadow-xl z-[1000] min-w-[200px] overflow-hidden">
                        <div className="px-4 py-3 border-b border-gray-200">
                            <h3 className="font-medium text-sm">Select Debug Tool</h3>
                        </div>
                        <div className="p-2">
                            <button
                                onClick={() => handleComponentSelect('email')}
                                className={`w-full text-left px-3 py-2 rounded text-sm transition-colors ${activeComponent === 'email'
                                    ? 'bg-blue-50 text-blue-700'
                                    : 'hover:bg-gray-100'
                                    }`}
                            >
                                Email Capture Debug
                                {activeComponent === 'email' && (
                                    <span className="float-right text-blue-700">✓</span>
                                )}
                            </button>
                            <button
                                onClick={() => handleComponentSelect('discount')}
                                className={`w-full text-left px-3 py-2 rounded text-sm transition-colors ${activeComponent === 'discount'
                                    ? 'bg-blue-50 text-blue-700'
                                    : 'hover:bg-gray-100'
                                    }`}
                            >
                                Discount Debug
                                {activeComponent === 'discount' && (
                                    <span className="float-right text-blue-700">✓</span>
                                )}
                            </button>
                            <button
                                onClick={() => handleComponentSelect('errors')}
                                className={`w-full text-left px-3 py-2 rounded text-sm transition-colors ${activeComponent === 'errors'
                                    ? 'bg-blue-50 text-blue-700'
                                    : 'hover:bg-gray-100'
                                    }`}
                            >
                                Error Boundary Testing
                                {activeComponent === 'errors' && (
                                    <span className="float-right text-blue-700">✓</span>
                                )}
                            </button>
                        </div>
                    </div>
                </>
            )}

            {/* Active Debug Component */}
            {renderDebugComponent()}
        </>
    )
}

export default DebugHolder
